// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-label {
  font-size: 20px;
  white-space: pre-line;
  margin-bottom: 20px;
}

ion-icon {
  transform: scale(1.15);
}

ion-item ion-icon {
  margin-right: 12px;
}

.field {
  margin-bottom: 1rem;
}

ion-fab {
  top: calc(var(--ion-safe-area-top) + 16px);
}

ion-grid {
  margin-top: calc(var(--ion-safe-area-top) + 72px);
  padding: 0 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,iDAAA;EACA,eAAA;AACF","sourcesContent":[".title-label {\n  font-size: 20px;\n  white-space: pre-line;\n  margin-bottom: 20px;\n}\n\nion-icon {\n  transform: scale(1.15);\n}\n\nion-item ion-icon {\n  margin-right: 12px;\n}\n\n.field {\n  margin-bottom: 1rem;\n}\n\nion-fab {\n  top: calc(var(--ion-safe-area-top) + 16px);\n}\n\nion-grid {\n  margin-top: calc(var(--ion-safe-area-top) + 72px);\n  padding: 0 25px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
